import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';


import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import ConfirmationModal from './common/ConfirmationModal';


export function GetTaskStatus (status) {
  const STATUSES = {
    "AVAILABLE": "Доступна для заполнения",
    "IN_PROGRESS": "Редактируется",
    "SENT": "Отправлена",
    "OUTDATED": "Просрочена",
    "RETURNED": "Возвращена",
    "EXPORTED_TO_EAS": "Выгружена в ИАС",
  }
  return STATUSES[status]
}

/*
export default function Task({}) {
  const [task, setTask] = useState(Object());

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  const media_url = useContext(MEDIA_URL);
  const navigate = useNavigate();

  let { taskId } = useParams();
  taskId = Number(taskId);

  React.useEffect(() => {

    let task = axios_api.get(api_url + '/manage_task/' + taskId, {
      headers: {"Authorization": token},
    });

    task.then(
      (result) => {
        let apiReturnedTask = result.data;
        setTask(apiReturnedTask);
      },
      (error) => {
        console.log(error)
        setTask([]);
      }
    );

  }, []);


  return (
    <>
      <h3 className="m-3"><Link to={`/`}>к списку заданий</Link></h3>
    </>
  )
}
*/